import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { streams } from '../utils/streamUtils';
import { RecorderState } from '../../store';

const DisplayPreview = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const { mediaStreams } = useSelector(
    (state: RecorderState) => state.recorder,
  );

  const hasVideoTracks =
    streams.displayMediaStream?.getVideoTracks().length > 0;

  useEffect(() => {
    const stream = streams.displayMediaStream;
    if (videoRef.current && stream && hasVideoTracks) {
      videoRef.current.srcObject = stream;
      videoRef.current.muted = true;
      videoRef.current.play();
    }
  }, [mediaStreams, hasVideoTracks]);

  // Only render if there are actual video tracks
  if (!hasVideoTracks) {
    return null;
  }

  return (
    /* eslint-disable-next-line jsx-a11y/media-has-caption */
    <video
      ref={videoRef}
      className="block w-full h-auto rounded-lg overflow-hidden object-contain object-left"
      aria-label="Screen recording preview"
    />
  );
};

export default DisplayPreview;
